export default __webpack_public_path__ + "static/media/4_1_hl.a261c9e9.png";